<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav [showSegments]="'messaging-rules'"></sbnb-gx-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-messaging-rules'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">{{ activeSegmentTitle ? activeSegmentTitle : 'Messaging rules' }}</h2>
      </sbnb-page-header>
      <h2>{{ activeSegmentTitle ? activeSegmentTitle : 'Messaging rules' }}</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'gx-messaging-rules'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'gx-messaging-rules'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        fxFlex
        componentName="messaging-rules"
        [hideSaveSegment]="true"
        [defaultFilters]="segmentFilterDefaults"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
      <span *ngIf="!segmentFilterDefaults" fxFlex></span>
      <sbnb-search-bar
        placeholderText="Search..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      <button type="submit" mat-flat-button class="button__small button__add-new" (click)="addNewClicked()">
        + Add new
      </button>
    </div>

    <div *ngIf="loading" class="table__no-items">Loading messaging rules...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="(!loading && !rules) || rules?.length === 0"
        icon="message"
        text="No messaging rules found matching these filters"
        [buttons]="[{ id: 'new', label: 'Add new messaging rule' }]"
        (button)="addNewClicked()"></sbnb-no-items>

      <div *ngIf="rules && rules.length > 0" class="rules__container">
        <div fxLayout fxLayoutGap="18px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex="32px">Status</div>
          <div fxFlex>Rule name</div>
          <div fxFlex>Sending time</div>
          <div fxFlex="120px">Hosts</div>
          <div fxFlex="120px">Properties</div>
          <div fxFlex="140px">Platforms</div>
        </div>
        <a
          *ngFor="let rule of rules"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="18px"
          [routerLink]="['/gx/rule/' + rule.id]">
          <mat-slide-toggle
            [checked]="rule.active"
            (click)="$event.stopPropagation()"
            (change)="activateOrDeactivateRule(rule, $event)"></mat-slide-toggle>

          <div fxFlex fxHide.lt-md class="rule__title ellipsis">
            {{ rule.name }}
          </div>

          <div fxHide.gt-sm class="rule__title ellipsis cera-heading" fxFlex>
            {{ rule.name }}
            <br />
            <span class="text__small mobile__event-short">{{ rule.event_short }}</span>
          </div>

          <div fxHide.lt-md fxFlex class="rule__when" fxLayoutAlign="start center" fxLayoutGap="8px">
            <span class="text__small" fxFlex>{{ rule.event_short }}</span>
          </div>

          <div fxHide.lt-md fxFlex="120px" fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-hosts [allHosts]="rule.all_hosts" [hosts]="rule.host_list" [ruleName]="rule.name"></sbnb-hosts>
          </div>

          <div
            fxFlex="none"
            fxFlex.gt-sm="120px"
            fxLayoutAlign="start center"
            fxLayoutGap="8px"
            fxLayoutAlign.lt-md="end center">
            <sbnb-avatar-group
              [items]="rule.property_list"
              [allItems]="rule.all_properties"
              [itemsForLabel]="rule.name"></sbnb-avatar-group>
          </div>

          <div fxFlex="140px" fxHide.lt-md fxLayoutGap="8px" fxLayoutAlign="start center">
            <sbnb-scoping-icons
              class="hidden md:flex"
              [showTooltips]="false"
              [scoped]="[
                (rule | doesRuleHavePlatform: 'direct') ||
                (rule | doesRuleHavePlatform: 'manual') ||
                (rule | doesRuleHavePlatform: 'gvr')
                  ? 'hospitable'
                  : null,
                (rule | doesRuleHavePlatform: 'airbnb') ? 'airbnb' : null,
                (rule | doesRuleHavePlatform: 'homeaway') ? 'homeaway' : null,
                (rule | doesRuleHavePlatform: 'booking') ? 'booking' : null,
                (rule | doesRuleHavePlatform: 'agoda') ? 'agoda' : null
              ]"></sbnb-scoping-icons>

            <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu" [suppressClick]="true"></sbnb-more-menu-trigger>
            <mat-menu #actionsMenu="matMenu">
              <button mat-menu-item disableRipple (click)="copyRuleset(rule.id)">
                <span fxLayoutAlign="start center" fxLayoutGap="6px">
                  <img src="/assets/iconography/copy.svg" alt="Copy" />
                  <span>Copy</span>
                </span>
              </button>
              <button mat-menu-item disableRipple (click)="deleteRule(rule.id)">
                <span fxLayoutAlign="start center" fxLayoutGap="6px">
                  <img src="/assets/iconography/delete.svg" alt="Delete" />
                  <span>Delete</span>
                </span>
              </button>
            </mat-menu>
          </div>
        </a>
      </div>
    </ng-container>
    <sbnb-pagination
      *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
